import React from 'react'

interface EmptyStateProps {
  title: string
  description?: string
  actionButton?: React.ReactNode
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, description, actionButton }) => {
  return (
    <div className='col-12 text-center py-5'>
      <h4>{title}</h4>
      {description && <p>{description}</p>}
      {actionButton && <div className='mt-3'>{actionButton}</div>}
    </div>
  )
}

export default EmptyState
